class LocalTimeElement extends HTMLElement {
  connectedCallback() {
    this._hh = this.querySelector(".hh");
    this._mm = this.querySelector(".mm");

    if (!this._hh || !this._mm) return;

    const fmt = new Intl.DateTimeFormat("de-DE", {
      hour: "2-digit",
      minute: "2-digit",
      timeZone: "Europe/Berlin",
    });

    const tick = () => {
      const now = new Date();
      const parts = fmt.formatToParts(now);
      this._hh.textContent = parts.find((p) => p.type === "hour").value;
      this._mm.textContent = parts.find((p) => p.type === "minute").value;
      this._timer = setTimeout(tick, (60 - now.getSeconds()) * 1000);
    };

    tick();
  }

  disconnectedCallback() {
    clearTimeout(this._timer);
  }
}

customElements.define("local-time", LocalTimeElement);
